module.exports = __webpack_public_path__ + "img/rule.5d6eab60.png";